import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { CreateAdInputComponent } from '@shared/components';

@Component({
  selector: 'aayn-ad-type-section',
  templateUrl: './ad-type-section.component.html'
})
export class AdTypeSectionComponent {
  @Input() header = '';
  @Input() description = '';
  @Input() icon?: string;
  @Input() containerClass = '';
  @Input() iconDirection: 'left' | 'right' = 'left';
  @Input() reGenerateButtonText = 'Re-generate';
  @Input() isReGenerateVisible = false;
  @Output() reGenerateClick = new EventEmitter<void>();
  @Input() isReGenerateLoading = false;
  @ContentChildren(CreateAdInputComponent, { descendants: true })
  createAdInputComponents!: QueryList<CreateAdInputComponent>;
}
